const Marionette = require('lib/marionette')
const _ = require('lib/underscore')
const $ = require('lib/jquery')
const BaseModel = require('lib/base_model')
const template = require('./ledge.html')
const styles = require('./ledge.less')
const log = require('log').create('ledge') // eslint-disable-line
require('jquery-add-prefixed-class')

const FADE_ALLOWANCE = 1000

/*
TODO:
1. Replace with ledge module sitewide: survey_bar etc.
2. Apply module/button for buttons
3. ledge to just be a simple view that accepts options.viewClass and options.viewOptions,
and shows the view in a region inside itself
*/

const LedgeView = Marionette.View.extend({

    displayName: 'LedgeView',

    template,

    styles,

    className: 'ledge',

    initialize(options) {
        this.initializeOptions()
        this.initializeModel()

        // ledge shows itself when created
        this.show()
    },

    initializeOptions() {
        _.defaults(this.options, {
            close_button: false,
        })
    },

    initializeModel() {
        this.model = new BaseModel()
        this.model.set(this.options)
    },

    ui: {
        content: '.ledge-content',
        close: '.ledge-close',
    },

    events: {
        'click @ui.close': 'close',
    },

    onRender() {
        this.showContent()

        _.defer(() => {
            this.fadeIn()
        })
    },

    showContent() {
        if (this.options.ViewClass) {
            this.addRegion('content', { el: this.ui.content })
            this.view = new this.options.ViewClass(this.options.viewOptions)
            this.listenTo(this.view, 'before:destroy', this.destroy)
            this.showChildView('content', this.view)

        } else if (this.options.html) {
            this.ui.content.html(this.options.html)

        } else if (this.options.text) {
            this.ui.content.text(this.options.text)

        } else if (__DEBUG__) {
            throw new Error('Ledge requires a options.text, options.html, or options.ViewClass.')
        }
    },

    fadeIn() {
        this.$el.addPrefixedClass('fade', 'in')
    },

    fadeOut() {
        this.$el.addPrefixedClass('fade', 'out')
    },

    show() {
        $.body.append(this.render().el)
        $.body.addClass('has-ledge')
        this.triggerMethod('attach')
    },

    close() {
        this.trigger('dismiss')
        this.fadeOut()
        $.body.removeClass('has-ledge')
        setTimeout(() => {
            this.destroy()
        }, FADE_ALLOWANCE)
    },

    onBeforeDestroy() {
        this.$el.remove()
    },

})

module.exports = LedgeView
